import cacheService from '../../../services/cacheService';
import { BrandCode } from '../../curriculum';

export const setRecentlyPaired: (items: { name: string; subtitle: string; brandCode?: BrandCode }[]) => void = items =>
  cacheService.set('recentlyPaired', items);
export const getRecentlyPaired: () => { name: string; subtitle: string; brandCode?: BrandCode }[] | undefined = () =>
  cacheService.get('recentlyPaired');
export const deleteRecentlyPaired: () => void = () => cacheService.remove('recentlyPaired');
